import React from "react";
import Select from "../../Atomes/Select/Select";
import SelectByCollaboratorTasks from "../../Atomes/Select/SelectByCollaboratorTasks";
import ButtonWithOnClickAction from "../../Atomes/Buttons/ButtonWithOnClickAction";

const FilterTwoSelectsButton = ({
    defaultValue, options, firstValue, firstOnChange,
    secondDefaultValue, secondOptions, secondValue, secondOnChange,
    isTasksCollaboratorFilter,
    onClickButton
}) => {
    return (
        <div className={"mbe-filter"}>
            <Select styleSelect={"select-custom-secondary"} onChange={firstOnChange}
                defaultValue={defaultValue} data={options} value={firstValue} />
            { isTasksCollaboratorFilter ? (
                <SelectByCollaboratorTasks 
                    styleSelect={"select-custom-secondary"} 
                    onChange={secondOnChange} 
                    defaultValue={secondDefaultValue}
                    data={secondOptions} 
                    value={secondValue}
                />
            ) : (
                <Select styleSelect={"select-custom-secondary"} onChange={secondOnChange}
                    defaultValue={secondDefaultValue} data={secondOptions} value={secondValue}/>
            )}
            {/* <ButtonWithOnClickAction title={"Exporter"} styleButton={"btn-default btn-default-blue btn-download color-primary"} isActive={true} onClick={onClickButton}/> */}
        </div>
    )
}

export default FilterTwoSelectsButton;